// chipText bgColor = very bad -> alert, bad -> warning, normal-> dustGreen , good ->dustBlue
const PM10_TYPES = {
  GOOD: {
    text: '좋음',
    color: 'dustBlue',
    class: 'good'
  },
  MODERATE: {
    text: '보통',
    color: 'dustGreen',
    class: 'normal'
  },
  POOR: {
    text: '나쁨',
    color: 'warning',
    class: 'bad'
  },
  BAD: {
    text: '매우나쁨',
    color: 'alert',
    class: 'very_bad'
  }
}

const PM25_TYPES = {
  GOOD: {
    text: '좋음',
    color: 'dustBlue',
    class: 'good'
  },
  MODERATE: {
    text: '보통',
    color: 'dustGreen',
    class: 'normal'
  },
  POOR: {
    text: '나쁨',
    color: 'warning',
    class: 'bad'
  },
  BAD: {
    text: '매우나쁨',
    color: 'alert',
    class: 'very_bad'
  }
}

const getPm10Type = (pm10) => {
  let parse = 0;

  try {
    parse = parseInt(pm10, 10);
  } catch(e) {
    console.error(e);
  }

  if (parse <= 30) {
    return PM10_TYPES.GOOD;
  } else if (parse <= 80) {
    return PM10_TYPES.MODERATE;
  } else if (parse <= 150) {
    return PM10_TYPES.POOR;
  } else {
    return PM10_TYPES.BAD;
  }
}

const getPm25Type = (pm25) => {
  let parse = 0;

  try {
    parse = parseInt(pm25, 10);
  } catch(e) {
    console.error(e);
  }

  if (parse <= 15) {
    return PM25_TYPES.GOOD;
  } else if (parse <= 35) {
    return PM25_TYPES.MODERATE;
  } else if (parse <= 75) {
    return PM25_TYPES.POOR;
  } else {
    return PM25_TYPES.BAD;
  }
}

export default {
  getPm10Type,
  getPm25Type
}